// Granular admin sections covered by the broad umbrella groups. Holding the
// umbrella ('content' / 'interpreters') implicitly grants its children, so
// existing council members keep full access while new granular grants work too.
export const CONTENT_CHILDREN = new Set([
  'news', 'events', 'board', 'pages', 'media', 'translations', 'periodicals', 'legal',
]);
export const INTERPRETER_CHILDREN = new Set(['dues', 'profile_edits']);

// Member ('interpreter') accounts never have admin-panel permissions. Every
// other non-admin role (council, asistente, or any custom staff role) uses the
// granular permission list on the user document.
export const NON_GRANULAR_ROLES = new Set(['admin', 'interpreter']);
export function isGranularRole(role) {
  return !!role && !NON_GRANULAR_ROLES.has(role);
}
export function isStaffRole(role) {
  return role === 'admin' || isGranularRole(role);
}

// True if the user may access a section gated by `perm`.
// Supports legacy ('content'), granular ('content:view') and umbrella inheritance.
export function canAccess(user, perm) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (perm === 'any') return true;
  if (perm === 'admin') return false;
  if (!isGranularRole(user.role)) return false;

  const perms = user.permissions || [];
  const has = (g) => perms.includes(g) || perms.some((p) => typeof p === 'string' && p.startsWith(`${g}:`));

  if (has(perm)) return true;
  if (CONTENT_CHILDREN.has(perm) && has('content')) return true;
  if (INTERPRETER_CHILDREN.has(perm) && has('interpreters')) return true;
  return false;
}
